import { render, staticRenderFns } from "./AddQyrg.vue?vue&type=template&id=c469fbbc&scoped=true&"
import script from "./AddQyrg.vue?vue&type=script&lang=js&"
export * from "./AddQyrg.vue?vue&type=script&lang=js&"
import style0 from "../listStyle.css?vue&type=style&index=0&id=c469fbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469fbbc",
  null
  
)

export default component.exports